import axios from "axios";
import * as ENV from "../Util/env";
async function GetLocations() {
    try {
        return await axios.get(ENV.APIBaseURL + "/locations", {
            //headers: {
            //    'Cache-Control': 'max-age=180',
            //}
        });
    } catch (error) {
        console.log(error);
    }
}

async function GetTopics() {
    try {
        return await axios.get(ENV.APIBaseURL + "/Topics", {
            //headers: {
            //    'Cache-Control': 'max-age=180',
            //}
        });
    } catch (error) {
        console.log(error);
    }
}

async function GetQuestions({ filteredYear, LocationAbbr } = {}) {
    try {
        const params = new URLSearchParams();
        if (filteredYear) params.append("filteredYear", filteredYear);
        if (LocationAbbr) params.append("LocationAbbr", LocationAbbr);
        const qs = params.toString();
        return await axios.get(
            ENV.APIBaseURL + "/Questions" + (qs ? `?${qs}` : ""),
            {
                //headers: {
                //    'Cache-Control': 'max-age=180',
                //}
            }
        );
    } catch (error) {
        console.log(error);
    }
}

async function GetSubQuestions(subQuestionId, year) {
    try {
        return await axios.get(
            ENV.APIBaseURL +
            "/TableData/SubQuestions?QuestionId=" + subQuestionId +
            "&Year=" + year
        );
    } catch (error) {
        console.log(error);
    }
}

async function GetYears({
    questionId,
    subQuestionId,
    locationAbbr,
    subQuestionText,
    summaryText,
    matchByText = ENV.EnableSubQuestionTextMatching,
}) {
    try {
        const params = new URLSearchParams();
        if (questionId) params.append("QuestionId", questionId);
        if (locationAbbr) params.append("LocationAbbr", locationAbbr);
        if (subQuestionId) params.append("SubQuestionId", subQuestionId);
        if (matchByText) {
            params.append("MatchByText", "true");
            if (subQuestionText) params.append("SubQuestionText", subQuestionText);
            if (summaryText) params.append("SummaryText", summaryText);
        }
        return await axios.get(`${ENV.APIBaseURL}/Years?${params.toString()}`);
    } catch (error) {
        console.log(error);
    }
}

/**
 * Get all question IDs that have data available for a specific location.
 * This is a single API call that replaces multiple GetYears calls for dashboard filtering.
 * @param {string} locationAbbr - The location abbreviation (e.g., "XX", "AL", "CA")
 * @returns {Promise<{data: string[]}>} Array of question IDs available for the location
 */
async function GetQuestionAvailability(locationAbbr) {
    try {
        return await axios.get(
            ENV.APIBaseURL +
            "/QuestionAvailability?LocationAbbr=" +
            locationAbbr
        );
    } catch (error) {
        console.log(error);
    }
}

async function GetSubQuestionAllLocations({ subQuestionId, questionId, year }) {
    try {
        return await axios.get(
            ENV.APIBaseURL +
            "/TableData/SubQuestion/AllLocations?QuestionId=" +
            questionId +
            "&SubQuestionId=" +
            subQuestionId +
            "&Year=" +
            year
        );
    } catch (error) {
        console.log(error);
    }
}

async function GetQuestionDataAllLocations({ questionId, year }) {
    try {
        return await axios.get(
            ENV.APIBaseURL +
            "/TableData/Question/AllLocations?QuestionId=" +
            questionId +
            "&Year=" +
            year
        );
    } catch (error) {
        console.log(error);
    }
}

async function GetQuestionOneLocation({
    locationAbbr,
    questionId,
    year,
}) {
    try {
        return await axios.get(
            ENV.APIBaseURL +
            "/TableData/Question/OneLocation?QuestionId=" +
            questionId +
            "&LocationAbbr=" +
            locationAbbr +
            "&Year=" +
            year
        );
    } catch (error) {
        console.log(error);
    }
}
async function GetPatternsOverTime({
    locationAbbr,
    questionId,
    subQuestionId,
    subQuestionText,
    summaryText,
    matchSubQuestionByText = ENV.EnableSubQuestionTextMatching,
}) {
    try {
        const params = new URLSearchParams();
        if (questionId !== undefined && questionId !== null) params.append("QuestionId", questionId);
        if (locationAbbr !== undefined && locationAbbr !== null) params.append("LocationAbbr", locationAbbr);
        // Always include SubQuestionId (empty string signals no subquestion)
        if (subQuestionId !== undefined && subQuestionId !== null) params.append("SubQuestionId", subQuestionId);
        // Always send MatchSubQuestionByText so the API knows the explicit intent
        params.append("MatchSubQuestionByText", matchSubQuestionByText ? "true" : "false");
        if (matchSubQuestionByText && subQuestionText) {
            params.append("SubQuestionText", subQuestionText);
        }
        // When SubQuestionText is empty, fall back to SummaryText for matching
        if (matchSubQuestionByText && !subQuestionText && summaryText) {
            params.append("SummaryText", summaryText);
        }

        return await axios.get(`${ENV.APIBaseURL}/TableData/PatternsOverTime?${params.toString()}`);
    } catch (error) {
        console.log(error);
    }
}

// New: Comparison endpoint for two-year comparisons across locations
// Params: {
//   questionId, subQuestionId, year, compareYear,
//   locationAbbr,               // 'ALL' or specific abbr
//   includeLocationTypes,       // array of strings, e.g., ['State']
//   includeNationwide = true,
//   alpha = 0.05
// }
async function GetComparison({
    questionId,
    subQuestionId,
    subQuestionText,
    summaryText,
    year,
    compareYear,
    locationAbbr,
    compareLocationAbbr,
    includeLocationTypes = ["State"],
    includeNationwide = true,
    alpha = 0.05,
    matchSubQuestionByText = ENV.EnableSubQuestionTextMatching,
}) {
    try {
        const params = new URLSearchParams();
        if (questionId) params.append("QuestionId", questionId);
        if (subQuestionId) params.append("SubQuestionId", subQuestionId);
        if (subQuestionText) params.append("SubQuestionText", subQuestionText);
        if (!subQuestionText && summaryText) params.append("SummaryText", summaryText);
        if (year) params.append("Year", year);
        if (compareYear) params.append("CompareYear", compareYear);
        if (locationAbbr) params.append("LocationAbbr", locationAbbr);
        if (compareLocationAbbr) params.append("CompareLocationAbbr", compareLocationAbbr);
        if (includeLocationTypes && includeLocationTypes.length) {
            // API expects CSV for IncludeLocationTypes
            params.append("IncludeLocationTypes", includeLocationTypes.join(","));
        }
        params.append("IncludeNationwide", includeNationwide ? "true" : "false");
        if (alpha) params.append("Alpha", alpha);
        // Pass matchSubQuestionByText parameter - use the passed value, not the env var directly
        params.append("MatchSubQuestionByText", matchSubQuestionByText ? "true" : "false");
        return await axios.get(`${ENV.APIBaseURL}/TableData/Comparison?${params.toString()}`);
    } catch (error) {
        console.log(error);
    }
}

export {
    GetLocations,
    GetTopics,
    GetQuestions,
    GetSubQuestions,
    GetYears,
    GetQuestionAvailability,
    GetQuestionOneLocation,
    GetSubQuestionAllLocations,
    GetQuestionDataAllLocations,
    GetPatternsOverTime,
    GetComparison
};